import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7448d5f8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=7448d5f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7448d5f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7448d5f8')) {
      api.createRecord('7448d5f8', component.options)
    } else {
      api.reload('7448d5f8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7448d5f8&scoped=true&", function () {
      api.rerender('7448d5f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/gongdeBox/index.vue"
export default component.exports